module.exports = __webpack_public_path__ + "img/shape_rectangle--blue.64e3f57.png";